import { QUERY_KEYS } from '../../../../consts';
import { updateUserService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const updateUserAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER.UPDATE_USER,
  mutationFn: () => updateUserService,
  retry: 0,
});
